import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/font/agriculture-icons.css'
import './assets/font/kebai-icons.css'
import VueLocalStorage from 'vue-local-storage'

Vue.use(VueLocalStorage)
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.mixin({
  methods: {
    getAccessToken() {
      const token = VueLocalStorage.get("access_token");
      return token
    },

  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
